export default __webpack_public_path__ + "static/media/check.502df2c1.svg";